import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'

import { Topbar, BookameetingTopbar, BookameetingFooter } from './components'

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 60,
    height: '100%',
  },
  content: {
    minHeight: 'calc(100vh - 626.72px)'
    // height: '100%'
  }
}))

const Minimal = props => {
  const { children } = props

  const classes = useStyles()

  return (
    <div className={classes.root}>
      {/* <Topbar /> */}
      <BookameetingTopbar></BookameetingTopbar>
      <main className={classes.content}>{children}</main>
      <BookameetingFooter></BookameetingFooter>
    </div>
  )
}

Minimal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

export default Minimal
